import correctEndpointUrl from "../../constants/firebaseEndpoint";

export default async (userId) => {
  const response = await fetch(`${correctEndpointUrl}/addNewUserCredits`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    body: JSON.stringify({ userId }),
  });

  return response.json();
};
